module.exports = __webpack_public_path__ + "img/logo.65c3331e.png";